import React from 'react';

import { RemittanceManagement } from 'pages/remittance';
import { useAdminRemittanceManagementData } from './useAdminRemittanceManagementData';

export const AdminRemittanceManagement: React.FC = () => {
  const {
    remittances,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    processRemittance,
    siteProviders,
  } = useAdminRemittanceManagementData();
  return (
    <RemittanceManagement
      remittance={remittances}
      siteProviders={siteProviders}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      processRemittance={processRemittance}
    />
  );
};
